import Matter from "matter-js";

$(".photo-collection").imagesLoaded(function () {
  $(".photo-collection").masonry({
    itemSelector: ".page-draws-article-item",
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const path = window.location.pathname;
//   const links = document.querySelectorAll(".nav-item");

//   links.forEach((link) => {
//     const href = link.getAttribute("href");

//     // vérifie si l'URL se termine par le href
//     if (
//       path.endsWith(href) ||
//       (href === "index.html" && (path === "/" || path.endsWith("/index.html")))
//     ) {
//       link.classList.add("active");
//     }
//   });
// });

// Déterminer quelle page est active
// Attendre que tout soit chargé (y compris les extends)
window.addEventListener("load", function () {
  const currentPage = window.location.pathname.split("/").pop() || "index.html";
});

// const images = [
//   "image/title2/font1",
//   "image/title2/font2",
//   "image/title2/font3",
//   "image/title2/font4",
//   "image/title2/font5",
//   "image/title2/font6",
//   "image/title2/font7",
//   "image/title2/font8",
//   "image/title2/font9",
//   "image/title2/font10",
// ];

// let i = 0;
// const imgEl = document.getElementById("fontImage");

// setInterval(() => {
//   i = (i + 1) % images.length; // passe à l'image suivante, revient au début
//   imgEl.src = images[i];
// }, 1000); // change toutes les 1s
